import api from "PFCore/api";
import { TemplateConfiguration } from "PFTypes";

export type ExportResponse =
  | {
      fileUrl: string;
      message?: never;
    }
  | {
      fileUrl?: never;
      message: "enqueued";
    };

export interface InterestQuestionnairesResponse {
  entries: TemplateConfiguration[];
  meta: {
    total: number;
  };
}

export const fetchInterestQuestionnaires = () =>
  api<InterestQuestionnairesResponse>({
    url: "interest_questionnaires"
  });

export type FetchUrlMetadataResponse = {
  title: string | null;
  description: string | null;
  type: string | null;
  image: string | null;
  url: string | null;
};

export const fetchUrlMetadata = (url: string): Promise<FetchUrlMetadataResponse> =>
  api({
    url: "open_graph_parser",
    params: {
      url
    }
  });
